import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userLoginServices } from "../../services/loginServices";
import { useSnackbar } from "../../components/SnackbarProvider";
import { useLoading } from "../../context/loadingcontext";
import { useAuth } from "../../context/AuthContext";
import { setUserGroup, useMaterialUIController } from "../../context";
import CryptoJS from "crypto-js";
import NoAccessPage from "./NoAccessPage";
import { LOGIN_API_URL } from "../Utils/url";
import axios from "axios";
import { encryptData } from "../../layoutcontainers/DashboardLayout/components/Navbar/components/encripted";


const SECRET_KEY = "1234";
const AuthLoader = ({
  text = "Insurelogist",
  colorGradient = ["#00AA1C", "#11af2cff", "#1cd83bff", "#00AA1C"],
  size = 40,
  background = "rgba(255, 255, 255, 0.95)",
  duration = 2,
  gap = 8,
  barWidth = 240,
}) => {
  const letters = Array.from(text);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const { setAuthenticated } = useAuth();
  const [controller, dispatch] = useMaterialUIController();

  const [user, setUser] = useState({
    name: "",
    userName: "",
    email: "",
    picture: "",
    token: "",
    details: "",
  });

  const [pageState, setPageState] = useState({
    animation: false,
  });

  // Animation styles injected once
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.type = "text/css";
    styleTag.textContent = `
      @keyframes hf-flip {
        0% { transform: perspective(400px) rotateX(0deg) translateY(0); opacity: 1; }
        28% { transform: perspective(400px) rotateX(12deg) translateY(-6%); opacity: 0.95; }
        50% { transform: perspective(400px) rotateX(180deg) translateY(-34%); opacity: 0.5; }
        72% { transform: perspective(400px) rotateX(10deg) translateY(-4%); opacity: 0.95; }
        100% { transform: perspective(400px) rotateX(0deg) translateY(0); opacity: 1; }
      }
      @keyframes hf-message-pulse {
        0% { transform: translateY(0); opacity: 0.9; }
        50% { transform: translateY(-4px); opacity: 1; }
        100% { transform: translateY(0); opacity: 0.9; }
      }
      @keyframes gradient-shift {
        0% { background-position: 0% 50%; }
        100% { background-position: 200% 50%; }
      }
    `;
    document.head.appendChild(styleTag);
  }, []);

  // Read encrypted data from URL, decrypt, and login
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const encryptedData = params.get("data");
  //   const encryptedDatas = params.get("data");

  //   if (encryptedData) {
  //     try {
  //       localStorage.setItem("encrypted",  encryptedDatas);
  //       const bytes = CryptoJS.AES.decrypt(encryptedData, "1234");
  //       console.log("bytes", bytes);
  //       const creds = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //       console.log("Decrypted credentials:", creds);

  //       handleSignIn(creds?.email, creds.password)
  //     } catch (err) {
  //       console.error("Decryption failed:", err);
  //     }
  //   }
  // }, []);
  useEffect(() => {
    //  handleSignIn("manager1@keelis.com", "12345678");
    const params = new URLSearchParams(window.location.search);
    const encryptedData = params.get("data");
    const encryptedDatas = params.get("data");

    console.log("encryptedData", encryptedDatas);

    if (encryptedData) {
      try {
        localStorage.setItem("encrypted",  encryptedDatas);
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const creds = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        console.log("Decrypted credentials:", creds);

        // Auto-login using creds directly (avoid async state delay)
        handleSignIn(creds?.email, creds.password);
      } catch (err) {
        console.error("Decryption failed:", err);
      }
    }
  }, []);

  // const handleSignIn = async (emailParam, passwordParam) => {
  //   const { success, message } = await userLoginServices(
  //     emailParam,
  //     passwordParam
  //   );
  //    if (success) {
  //     navigate("/insurance");
  //   }
  //   else{
  //      setPageState({
  //       ...pageState,
  //       animation: true,
  //     });
  //   }
  //   showSnackbar(message, success ? "success" : "error");
  //   // setAuthenticated(success);
  //   // localStorage.setItem("authenticated", JSON.stringify(success));

   
  // };

  const handleSignIn = async (emailParam, passwordParam) => {
    console.log("ds",emailParam, passwordParam)
    try {
      const res = await axios.post(`${LOGIN_API_URL}users/v1/login/`, {
        email: emailParam,
        password: passwordParam,
      });

      const success = res?.data?.success;
      const message = res?.data?.message;
      showSnackbar(message, success ? "success" : "error");
      if (success) {
        navigate("/insurance");
        localStorage.setItem("rememberedEmail", encryptData(emailParam));
        localStorage.setItem(
          "rememberedPassword",
          encryptData(passwordParam)
        );
      } else {
         setPageState({
        ...pageState,
        animation: true,
      });
      }
    } catch (error) {
         setPageState({
        ...pageState,
        animation: true,
      });
    }
  };

  const gradientCSS = `linear-gradient(120deg, ${colorGradient.join(", ")})`;

  return (
     <>
      {pageState.animation ? (
        <>
          <NoAccessPage />
        </>
      ) : (
      <>
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999999999999999,
        background,
        backdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "20px 28px",
          borderRadius: "12px",
        }}
      >
 
        <div style={{ display: "inline-flex", gap: `${gap}px` }}>
          {letters.map((ch, idx) => {
            const delay = (idx * 0.12).toFixed(2);
            return (
              <span
                key={idx}
                style={{
                  display: "inline-block",
                  fontWeight: 700,
                  fontSize: `${size}px`,
                  textTransform: "uppercase",
                  backgroundImage: gradientCSS,
                  backgroundSize: "200% 200%",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  animation: `
                    hf-flip ${duration}s cubic-bezier(.2,.9,.2,1) infinite,
                    gradient-shift 3s linear infinite
                  `,
                  animationDelay: `${delay}s, 0s`,
                }}
              >
                {ch === " " ? "\u00A0" : ch}
              </span>
            );
          })}
        </div>

        
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: `${barWidth}px`,
              height: "8px",
              borderRadius: "999px",
              backgroundImage: gradientCSS,
              backgroundSize: "300% 100%",
              animation: "gradient-shift 6s ease-in-out infinite",
              marginBottom: "8px",
            }}
          />
          <div
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "rgba(0,0,0,0.6)",
              animation: "hf-message-pulse 1.6s ease-in-out infinite",
            }}
          >
            Securing your workspace…
          </div>
        </div>
      </div>
    </div>
    </> )}
    </>
  );
};

export default AuthLoader;
